
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-lock-open",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"secondary",attrs:{"d":"M12 19v3H5a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h7v3a2 2 0 00-1 3.73V18a1 1 0 001 1z"}}),_c('path',{staticClass:"primary",attrs:{"d":"M12 19a1 1 0 001-1v-1.27A2 2 0 0012 13v-3h7a2 2 0 012 2v8a2 2 0 01-2 2h-7v-3zm5-12a1 1 0 01-2 0 3 3 0 00-6 0v3H7V7a5 5 0 1110 0z"}})])
          )
        }
      }
    